<template>
  <CCard style="margin-top: 10px">
    <CCardHeader>
      <strong> Add product details </strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CRow>
            <CCol sm="6">
              <CInput
                label="Product name"
                v-model="product.productname"
                placeholder="Enter Product name"
              />
            </CCol>
            <CCol sm="6">
              <CTextarea
                label="Description"
                placeholder="Content..."
                horizontal
                rows="3"
                v-model="product.description"
              />
            </CCol>
            <CCol sm="6">
              <CTextarea
                label="Detail"
                placeholder="Content..."
                horizontal
                rows="3"
                v-model="product.detail"
              />
            </CCol>
            <CCol sm="6">
              <CRow>
                <CCol sm="6">
                  <span>Product Image</span>
                  <input
                    v-if="imgget"
                    type="file"
                    accept="image/jpeg"
                    @change="uploadImage"
                  />
                </CCol>

                <CCol sm="6">
                  <img
                    v-if="imgpre"
                    :src="this.product.productimg"
                    style="float: right; width: 200px; height: 200px"
                  />
                  <CButton
                    v-if="productimgbtn"
                    block
                    color="success"
                    style="float: right; width: 100px"
                    @click="saveproductlogo()"
                    >upload</CButton
                  >
                </CCol>
              </CRow>
            </CCol>

            <CCol sm="6">
              <br />
              <CInput
                label="Costprice"
                v-model="product.costPrice"
                horizontal
              />
            </CCol>

            <CCol sm="6">
              <br />
              <CInput
                label="salePrice"
                v-model="product.salePrice"
                horizontal
              />
            </CCol>
            <CCol sm="6">
              <CRow>
                <CCol sm="4"> onSale </CCol>
                <CCol sm="8">
                  <!-- <Vselect
                    style="padding-top: 7px; height: 36px"
                    :options="options1"
                    placeholder="Please select"
                    v-model="vonSale"
                    searchable
                  /> -->
                  <CSwitch
                    class="mx-1"
                    color="primary"
                    :checked.sync="product.onSale"
                    variant="opposite"
                    shape="pill"
                    v-bind="labelTxt1"
                  />
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="6">
              <CRow>
                <CCol sm="4"> InStock </CCol>
                <CCol sm="8">
                  <CSwitch
                    class="mx-1"
                    color="primary"
                    :checked.sync="product.inStock"
                    variant="opposite"
                    shape="pill"
                    v-bind="labelTxt"
                  />
                </CCol>
              </CRow>
            </CCol>
            <CCol sm="6">
              <br>
              <CInput label="Category" v-model="product.category" horizontal />
            </CCol>
          </CRow>
        </CCol>
        <br />
        <br />
        <CButton
          type="submit"
          size="sm"
          color="success"
          @click="saveProducts()"
          style="margin: auto; width: 100px; height: 32px; margin-top: 15px"
          >Save</CButton
        >
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import { APIService } from "../../../apiservice.js";
import { Vselect } from "@/components";
import Swal from "sweetalert2";
export default {
  components: {
    Vselect,
  },
  data() {
    return {
      vonSale: "",
      vinStock: "",
      imageTypes: ["image/jpeg", "image/png", "image/jpg"],
      imgget: true,
      imgpre: false,
      labelTxt: {
        labelOn: "yes",
        labelOff: "no",
      },
      labelTxt1: {
        labelOn: "yes",
        labelOff: "no",
      },
      options1: ["Yes", "No"],
      options2: ["Yes", "No"],
      productimgbtn: "",
      product: {
        productname: "",
        productimg: "",
        description: "",
        detail: "",
        onSale: false,
        costPrice: "",
        category: "",
        inStock: false,
        salePrice: "",
      },
    };
  },
 
  methods: {
    saveproductlogo() {
      let self = this;
      let data = new FormData();
      data.append("file", self.productimgbtn);
      if (this.imageTypes.includes(this.productimgbtn.type)) {
        APIService.productimages(data).then(
          (res) => {
            if (res.status == 200) {
              this.product.productimg = res.data.location;
              this.productimgbtn = false;
              this.imgget = false;
              this.imgpre = true;
              this.$notify({
                timeout: 1000,
                message: "Company logo uploaded successfully.",
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              let msg = "Your file not uploaded. Please try again later";
              let type = "danger";
              this.notifyMsg(msg, type);
            }
          },
          (err) => {
            self.errMsg = "Cannot upload Profile Image2";
          }
        );
      } else {
        let msg = "Upload not allowed, Wrong file format.";
        let type = "danger";
        this.notifyMsg(msg, type);
      }
    },
    uploadImage(e) {
      this.productimgbtn = e.target.files[0];
    },
    saveProducts() {
      let name = this.product.productname;
      let description = this.product.description;
      let detail = this.product.detail;
      let costPrice = this.product.costPrice;
      let salePrice = this.product.salePrice;
      let onSale = this.product.onSale;
      let inStock = this.product.inStock;
      let img = this.product.productimg;
      let category = this.product.category;

      let data = {
        name,
        description,
        detail,
        costPrice,
        salePrice,
        onSale,
        inStock,
        img,
        category
      };
      APIService.saveproducts(data).then(
        (res) => {
          if (res.status == 200) {
         Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
            this.$router.push({ name: "cardDetails" });
          } else {
            let msg = "Your file not uploaded. Please try again later";
            let type = "danger";
            this.notifyMsg(msg, type);
          }
        },
        (err) => {
          self.errMsg = "Cannot upload Profile Image2";
        }
      );
    },
  },
};
</script>